// src/components/FileSelectorModal.js

import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { supabase } from '../../supabase';
import { FaFilePdf } from 'react-icons/fa';
import './FileSelectorModal.css';

Modal.setAppElement('#root');

export const FileSelectorModal = ({ isOpen, onRequestClose, onFileSelect }) => {
  const [pdfFiles, setPdfFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPdfFiles = async () => {
      if (isOpen) {
        setLoading(true);
        try {
          const { data: { session } } = await supabase.auth.getSession();
          if (!session) return;
          
          const { data, error } = await supabase
            .from('files')
            .select('*')
            .eq('uid', session.user.id)
            .ilike('fileName', '%.pdf');
            
          if (error) throw error;

          const files = data || [];
          files.sort((a, b) => a.fileName.localeCompare(b.fileName));
          setPdfFiles(files);
        } catch (error) {
          console.error("Error fetching PDF files:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchPdfFiles();
  }, [isOpen]);

  const handleFileClick = (file) => {
    onFileSelect(file);
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Select a File to Attach"
      className="modal"
      overlayClassName="overlay"
      style={{ content: { maxWidth: '600px' } }}
    >
      <h2 style={{ marginBottom: '10px' }}>Attach a PDF File</h2>
      <p style={{ marginBottom: '20px', color: 'var(--color-text-secondary)'}}>Select a file to provide its content as context for your chat.</p>
      
      <div className="file-selector-list">
        {loading ? (
          <p>Loading files...</p>
        ) : pdfFiles.length > 0 ? (
          pdfFiles.map(file => (
            <button key={file.id} className="file-selector-item" onClick={() => handleFileClick(file)}>
              <FaFilePdf className="file-selector-icon" />
              <span>{file.fileName}</span>
            </button>
          ))
        ) : (
          <p>No PDF files found to attach.</p>
        )}
      </div>
    </Modal>
  );
};